import { validationErrors } from 'utils';

import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGIN_INTRANET,
  LOGIN_INTRANET_SUCCESS,
  LOGIN_INTRANET_FAILED,
  LOGIN_EXTRANET,
  LOGIN_EXTRANET_SUCCESS,
  LOGIN_EXTRANET_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  isIntranet: true,
  isLoggedIn: false,

  error: {},
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
    case LOGIN_INTRANET:
    case LOGIN_EXTRANET:
      return {
        ...state,
        loading: true,
        error: {},
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isIntranet: action.payload?.isIntranet ?? true,
      };

    case LOGIN_INTRANET_SUCCESS:
      return {
        ...state,
        loading: false,
        isIntranet: true,
        isLoggedIn: true,
      };

    case LOGIN_EXTRANET_SUCCESS:
      return {
        ...state,
        loading: false,
        isIntranet: false,
        isLoggedIn: true,
      };

    case LOGIN_FAILED:
    case LOGIN_INTRANET_FAILED:
    case LOGIN_EXTRANET_FAILED:
      return {
        ...state,
        loading: false,
        isLoggedIn: false,
        error: validationErrors(action.payload),
      };

    default:
      return state;
  }
};

export default login;
